export type SupplierInfo = {
    description: string
    additionalDescription: string
    addressType: AddressType
    street: string
    postbox: string
    zip: string
    city: string
    phone: string
    fax: string
    countryCode: string
    eMail: string
    url: string
}

export enum AddressType {
    general = 1,
    productSafetyInformation = 17,
}
